import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { images } from '../lib/assets';
export const mockupUrl = images.mockup;
export function Hero() {
  return <section className="w-full px-4 pb-6 pt-4 text-navy sm:pb-10 sm:pt-8" style={{
    background: 'radial-gradient(ellipse at 50% 60%, #FFFFFF 0%, #FBF8F3 55%, #E8F2EF 100%)'
  }} data-id="element-104" data-mp="9ka52wkpoovv">
      <div className="mx-auto max-w-5xl text-center" data-id="element-105" data-mp="129h37ug97cgl">
        <motion.span initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45
      }} className="inline-flex rounded-full border border-amber/50 bg-surface px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-amber" data-id="element-106" data-mp="1286262e70it6">Pour les praticiens holistiques</motion.span>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.05
      }} className="mx-auto mt-3 max-w-3xl font-serif text-[32px] leading-[1.05] tracking-tight text-navy sm:text-6xl" data-id="element-107" data-mp="nboov5mg0u3z">Vos séances de tarot, de Reiki et de chakras, <span className="text-sage" data-id="element-108" data-mp="3j893p1w0vrk9">enfin organisées.</span></motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.14
      }} className="mx-auto mt-2 max-w-md text-sm leading-snug text-slate sm:text-lg" data-id="element-109" data-mp="3o7c1c19oavi7">6 volumes, 60 fiches A4 à imprimer et 5 bonus&#8239;: tout au même endroit, prêt à l’emploi.</motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mx-auto mt-3 max-w-xl" data-id="element-110" data-mp="30iawsp3yo4i7"><img src={mockupUrl} alt="Système Énergétique Tarot · Reiki · Chakras : le livre et des fiches à imprimer" width={1600} height={1280} fetchPriority="high" decoding="async" className="mx-auto block h-auto w-full bg-transparent object-contain" data-id="element-111" data-mp="35akmq552t4kh" /></motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.28
      }} className="mt-3" data-id="element-112" data-mp="2hkgl23bg7ew4"><CTAButton href="#complete-package" pulse size="large" data-id="element-113" data-mp="2lml8gkbazfab">JE VEUX MA BIBLIOTHÈQUE</CTAButton><p className="mx-auto mt-2.5 text-xs text-slate sm:text-sm" data-id="element-114" data-mp="s44itpsj1piy">⚡ Accès immédiat <span className="mx-1" data-id="element-115" data-mp="n9qira2x6u7y">·</span> 🖨️ Fiches A4 <span className="mx-1" data-id="element-116" data-mp="ic89fikzqczf">·</span> 🛡️ Protection 7 jours</p></motion.div>
      </div>
    </section>;
}